import { objectSpread2 as _objectSpread2, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { SwitchToggle as SwitchToggle$1 } from '@tesla/design-system-react';
import { useField } from 'informed';

/**
 * Renders a switch toggle
 */
function SwitchToggle(props) {
  var _useField = useField(_objectSpread2({
      type: 'checkbox'
    }, props)),
    informed = _useField.informed,
    fieldState = _useField.fieldState,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  var value = fieldState.value;
  return render( /*#__PURE__*/React.createElement(SwitchToggle$1, _extends({}, informed, {
    type: "checkbox",
    checked: !!value
    // error={formFieldContext.$showError}
    // errorLabel={formFieldContext.error}
  }, userProps, {
    inputRef: ref
  })));
}

export { SwitchToggle };
